import React from 'react'
import "./GetStarted.css"
const GetStarted = () => {
  return (
    <section className="g-wrapper">
        <div className="paddings innerWidth g-container">
            <div className="flexColCenter inner-container">
                <span className='primaryText'>Get Started with Real State</span>
                <span className='secondaryText'>Subscrive And Find Attractive Quotes
                    <br />
                    Find Your Property Soon
                </span>

                <button className="button">
                    <a href="mailto:legendarygray669@gmail.com">Get Started</a>
                </button>
               
            </div>
        </div>
        </section>
  )
}

export default GetStarted
